module.exports = __webpack_public_path__ + "ff655b7db70ec52550488c5d9784a272.pdf";